import { OrderedList } from '@tiptap/extension-list'

export type { OrderedListOptions } from '@tiptap/extension-list'
export { OrderedList } from '@tiptap/extension-list'

export default OrderedList
